/**
 * SSR-safe helpers for accessing browser globals
 * These functions check if we're in a browser environment before accessing browser-only APIs
 */

/**
 * Check if code is running in a browser environment
 * @returns {boolean} True if in browser, false if in Node.js/SSR
 */
export function isBrowser() {
  return typeof window !== 'undefined';
}

/**
 * Safely get the document object
 * @returns {Document|null} Document object or null if not in browser
 */
export function getDocument() {
  return isBrowser() ? document : null;
}

/**
 * Safely get the window object
 * @returns {Window|null} Window object or null if not in browser
 */
export function getWindow() {
  return isBrowser() ? window : null;
}

/**
 * Generate an asset URL safely in both browser and SSR environments
 * @param {string} path - Path to the asset
 * @returns {string} Full URL to the asset
 */
export function asset(path) {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // In browser, we can use window.location to build the URL
  if (isBrowser()) {
    const baseUrl = window.location.origin;
    return `${baseUrl}/${cleanPath}`;
  }
  
  // In SSR, return a relative path
  return `/${cleanPath}`;
}
